import React from "react";
import "./CampaignCard.css";

const CampaignCard = ({ card, onSelected, cardSelected }) => {
  return (
    <div
      className={
        cardSelected.Product === card.Product ? "card active " : "card"
      }
      onClick={() => onSelected(card)}
    >
      <div className="card__container">
        <div className="subvention-col-left">
          <div className="card__title">{card.Product}</div>
        </div>
      </div>
      <div className="card__right">
        <div className="card__block">
          <div className="card__block--label card__block--first">Score</div>
          <div className="card__block--value">{card.Score}</div>
        </div>
        <div className="card__block">
          <div className="card__block--label">Rank</div>
          <div className="card__block--value">
            {card.Place} / {card.Out_of}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignCard;
